import { IReduxAction } from '~/services/interfaces/common-interface';
import {
  SET_LOADING_DATA,
  SET_LOADING_SELECTS,
  SET_PAGE,
  SET_ROWS_PER_PAGE,
  SET_ROWS_COUNT,
  SET_ORDER,
  SET_ORDERBY,
  GET_ALL_SUCCESS,
  GET_BY_ID_SUCCESS,
  GET_FILTER_PRODUCT_SUCCESS,
  SEARCH,
  SET_LOADING_SEND,
  SET_LOADING_MODAL,
  GET_FILTER_SELECTS_SUCCESS
} from './product-technical-constants';

const INITIAL_STATE = {
  loadingData: false,
  loadingSend: false,
  loadingSelects: false,
  form: {
    data: null,
    errors: [],
    selects: null
  },
  list: {
    hasRemotePagination: true,
    allRows: [],
    rows: [],
    rowsCount: 0,
    page: 0,
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 25, 50, 100],
    order: 'asc',
    orderBy: 'name'
  },
  modal: {
    data: [],
    loadingModal: false
  }
};

const productPhotosReducer = (state: any = { ...INITIAL_STATE }, action: IReduxAction) => {
  switch (action.type) {
    case SET_LOADING_DATA: {
      return {
        ...state,
        loadingData: action.loading
      };
    }

    case SET_LOADING_SELECTS: {
      return {
        ...state,
        loadingSelects: action.loading
      };
    }

    case SET_LOADING_SEND: {
      return {
        ...state,
        loadingSend: action.loading
      };
    }

    case SET_LOADING_MODAL: {
      return {
        ...state,
        modal: {
          ...state.modal,
          loading: action.loading
        }
      };
    }

    case GET_FILTER_SELECTS_SUCCESS: {
      return {
        ...state,
        list: {
          ...state.list,
          selects: action.payload
        }
      };
    }

    case GET_ALL_SUCCESS: {
      return {
        ...state,
        list: {
          ...state.list,
          rows: action.payload?.products ?? [],
          allRows: action.payload?.products ?? [],
          rowsCount: action.payload?.rowsCount ?? state?.list?.rowsCount
        }
      };
    }

    case GET_BY_ID_SUCCESS: {
      return {
        ...state,
        form: {
          ...action.payload,
          data: {
            ...state.form.data,
            ...action.payload.data
          },
          selects: {
            ...state.form.selects,
            ...action.payload.selects
          }
        }
      };
    }

    case GET_FILTER_PRODUCT_SUCCESS: {
      return {
        ...state,
        form: {
          ...state.form,
          selects: {
            ...state.form.selects,
            products: action.payload
          }
        }
      };
    }

    case SET_PAGE: {
      return {
        ...state,
        list: {
          ...state.list,
          page: action.page
        }
      };
    }

    case SET_ROWS_PER_PAGE: {
      return {
        ...state,
        list: {
          ...state.list,
          rowsPerPage: action.rowsPerPage
        }
      };
    }

    case SET_ROWS_COUNT: {
      return {
        ...state,
        list: {
          ...state.list,
          rowsCount: action.payload?.rowsCount
        }
      };
    }

    case SET_ORDER: {
      return {
        ...state,
        list: {
          ...state.list,
          order: action.order
        }
      };
    }

    case SET_ORDERBY: {
      return {
        ...state,
        list: {
          ...state.list,
          orderBy: action.orderBy
        }
      };
    }

    case SEARCH: {
      const { queryString } = action;
      const results =
        queryString !== ''
          ? state.list.allRows.filter(
              (item: any) =>
                item?.name?.toLowerCase().startsWith(queryString.toLowerCase()) ||
                item?.name?.toLowerCase().includes(queryString.toLowerCase()) ||
                item?.externalCode?.toLowerCase().startsWith(queryString.toLowerCase()) ||
                item?.externalCode?.toLowerCase().includes(queryString.toLowerCase())
            )
          : state.list.allRows;

      return {
        ...state,
        list: {
          ...state.list,
          rows: [...results]
        }
      };
    }

    default:
      return state;
  }
};

export default productPhotosReducer;
